const workFrag = `
    id
    workType
    serviceId
    offers {
        serviceOffer {
            name
        }
    }
    parentWork {
        id
        workType
        serviceId
    }
`;

export const unbilledWorksFrag = `
    totalCount
    firstWork { ${workFrag} }
    lastWork { ${workFrag} }
`;
